import { SearchItem } from '@yiluhub/yilu-amp-types';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import routes from 'router/routes';

import { constructEurailBacklinkProps } from 'modules/eurail/utils/constructEurailBackLinkProps';
import { getEurailProductDetails } from 'modules/eurail/utils/getProductDetails';
import { PassType } from 'modules/eurail/utils/types';

/**
 * Hook to generate back link props for the Eurail traveller input page.
 */
export const useBackLinkProps = (eurailProduct: SearchItem | undefined | null) => {
  const navigate = useNavigate();

  return useMemo(() => {
    if (!eurailProduct) return null;

    const productDetails = getEurailProductDetails(eurailProduct);

    return constructEurailBacklinkProps('', routes.EURAIL_SEARCH_RESULTS, navigate, {
      to: productDetails.to,
      fareClass: productDetails.fareClass,
      pass: productDetails.pass ?? PassType.GLOBAL,
      adult: productDetails.numberOfAdults,
      child: productDetails.numberOfChildren,
      senior: productDetails.numberOfSeniors,
      youth: productDetails.numberOfYouths,
    });
  }, [eurailProduct, navigate]);
};
